import JSON5 from "json5";

import { getConfig } from "lib/get-config";
import { Part } from "lib/types";

export async function getPart(url: string) {
  const response = await fetch(url);
  const data = await response.text();
  // TODO: рассмотреть замену json5 на простой regex, оборачивающий ключи в кавычки, чтобы убрать зависимость
  return JSON5.parse(data);
}

export async function getContent(parts: Part[]) {
  const { contentUrl } = getConfig();
  const content = await Promise.all(
    parts.map(part => {
      const url = `${contentUrl}json/${part.url}`;
      return getPart(url);
    })
  );

  return content;
}
